import { register } from "@shopify/theme-sections";
import Swiper from "swiper";
import SwiperCore, { Navigation } from "swiper/core";

SwiperCore.use([Navigation]);

register('featured-articles', {

    onLoad: function() {
        this.slider = new Swiper('.js-featured-articles-slider', {
            slidesPerView: 1,
            watchSlidesVisibility: true,
            spaceBetween: 4,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                576: {
                    slidesPerView: 2
                }
            }
        })
    },

    onUnload: function() {
        this.slider.destroy();
    },
});
